// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"36419a0e","453":"858a60c2","455":"5ee793de"}[chunkId] + ".chunk.js";
};